import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {removeSearchSettings} from 'src/openapi/admin/apis/ConferenceSearchSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    onSuccess: () => void,
};

export const useRemoveSearch = ({onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((settingsId: number) => apiDispatch(
        removeSearchSettings({settingsId}),
    ), [apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
    });
};
